const CompareSvg = ({
  width = 18,
  height = 18,
  viewBox = '0 0 14 14',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68001 0C6.92602 3.15556e-05 7.1255 0.199472 7.1255 0.44549V2.77089H12.9145C13.1605 2.77093 13.36 2.97037 13.36 3.21638C13.36 3.46236 13.1605 3.66182 12.9145 3.66187H11.557L13.3128 7.17346C13.3818 7.31153 13.3745 7.47557 13.2934 7.60689C13.2122 7.73818 13.0687 7.81819 12.9144 7.8182H8.75805C8.60368 7.81818 8.46023 7.7382 8.37906 7.60689C8.29792 7.47558 8.29054 7.31153 8.35955 7.17346L10.1154 3.66187H7.1255V12.4689H9.4509C9.69688 12.4689 9.89636 12.6684 9.89639 12.9144C9.89639 13.1604 9.6969 13.3598 9.4509 13.3599H6.68461C6.68308 13.3599 6.68155 13.36 6.68001 13.36C6.6785 13.36 6.67692 13.3599 6.67541 13.3599H3.90912C3.66308 13.3599 3.46363 13.1604 3.46363 12.9144C3.46367 12.6684 3.66311 12.4689 3.90912 12.4689H6.23452V3.66187H3.24449L5.00023 7.17346C5.06923 7.31153 5.06197 7.47558 4.98083 7.60689C4.89967 7.7382 4.75621 7.81818 4.60184 7.8182H0.445512C0.291137 7.8182 0.1477 7.7382 0.0665224 7.60689C-0.0146225 7.47557 -0.022016 7.31154 0.0470074 7.17346L1.80286 3.66187H0.445512C0.199494 3.66187 5.36129e-05 3.46239 2.21247e-05 3.21638C2.21247e-05 2.97034 0.199475 2.77089 0.445512 2.77089H6.23452V0.44549C6.23452 0.199453 6.43397 0 6.68001 0ZM1.16645 6.92722H3.88091L2.52368 4.21264L1.16645 6.92722ZM9.47899 6.92722H12.1934L10.8362 4.21264L9.47899 6.92722Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default CompareSvg;
